import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class CandidateTransferService {
  getActiveCompanies() {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "admin/candidate-transfer/active-companies");
  }
  getJobsByCompanyId(companyId) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `admin/candidate-transfer/jobs-by-company/${companyId}`);
  }
  getStagesByJobPostId(jobPostId) {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + `admin/candidate-transfer/stages-by-job/${jobPostId}`);
  }
  transferCandidate(data) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "admin/candidate-transfer", data);
  }
  moveCandidate(data) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "admin/candidate-transfer/move", data);
  }
  getTransferHistories() {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "admin/candidate-transfer/histories");
  }
  deleteTransferHistories(ids) {
    const idsString = ids.join(",");
    return httpRequestAdmin.delete(process.env.REACT_APP_BACKEND_API_URL + `admin/candidate-transfer/remove?ids=${idsString}`);
  }
  regenerateCulturalFit(data) {
    return httpRequestAdmin.post(process.env.REACT_APP_BACKEND_API_URL + "admin/candidate/regenerate-cultural-fit", data);
  }
}

export default new CandidateTransferService();
